import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { setLocation } from "../redux/slices/locationSlice";
import { MenuItem } from "@material-ui/core";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setCalendar } from "../redux/slices/calendarSlice";
import Multiselect from "multiselect-react-dropdown";
import { FaPlus } from "react-icons/fa";
import { addOption } from "../redux/slices/capabilitiesSlice";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";
import CalendarMeetingIdField from "./CalendarMeetingIdField";
import { linkedCalendarIds } from "../utils/calendarProvisioning";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width:"95%",
  maxWidth: 450,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 4,
  maxHeight: "90vh",
  overflowY: "auto",
};
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "30ch",
      color: "primary",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "#19433E",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,

    overflow: "hidden",
  },
  label: {
    fontWeight: "bold",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem",
    width: 350,

    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 6,
  },
  capability: {
    margin: theme.spacing(1),
    display: "flex",
    flexDirection: "column",

    justifyContent: "center",
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "3.5%",
    marginTop: "2%",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    padding: "1rem",
  },
  divider: {
    margin: "20px 0",
  },
}));

export default function MyMeetingSpaceForm({ selectedOption ,locationOptions}) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setShowAdvanced(false);
    setFormData({
      name: "",
      capacity: "",
      locationId: "",
      calendarMeetingId: "",
      clientId: "",
      meetingspacetype: "",
      photoUrl: " ",
      calendarCredentialId: "",
      customProperties: {},
    });
    setNewKey("");
    setNewValue("");
  };
  const headers = useSelector((state) => state.header);

  const [userOptions, setUserOptions] = useState([]);

  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState(false);

  const oldMeetingSpaceData = useSelector((state) => state.allmeetingspaces);
  const [error, setError] = useState(false);
  const curremms = useSelector((state) => state.curremms);
  const capabilitiesOptions = useSelector((state) => state.capabilitiesOptions);
  const options = capabilitiesOptions.options;
  const groups = useSelector((state) => state?.groups?.groups);
 
  const [calendarOptions, setCalendarOptions] = useState([]);
  const calendarData = useSelector((state) => state.calendar);
  const api = localStorage.getItem("api");
  const [isChecked, setIsChecked] = useState(false);
  const [strictCheckValid, setStrictCheckValid] = useState();

  const dispatch = useDispatch();

  const handleOpen = () => {
    setOpen(true);
    handleCalendarData();
    addCustomFeaturesAsOptions();
    setFormData((prevFormData) => ({
      ...prevFormData,
      meetingspacetype: "",
    }));
    if (formData.meetingspacetype === "calendar") {
      setCalendarOptions(calendarData.calendar);
    } else {
      setCalendarOptions([]);
      delete formData.calendarCredentialId;
      delete formData.calendarMeetingId;
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    capacity: "",
    locationId: "",
    customProperties: {},
    clientId: "",
    meetingspacetype: "",
    calendarMeetingId: "",
    calendarCredentialId: "",
    photoUrl: "",
  });

  // Carries customProperties.calendarEntries, which is what turns the Calendar
  // Meeting ID field into a list of room names instead of a box to paste an id.
  const selectedCalendarCredential = (calendarOptions || []).find(
    (option) => option.id === formData.calendarCredentialId
  );

  const [newCapability, setNewCapability] = useState({
    name: "",
    icon: "",
    custom: true,
  });
  const [showInputFields, setShowInputFields] = useState(false);
  const [capacityCheckValue, setCapacityCheckValue] = useState(0);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;
   
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };
  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCapability({
      ...newCapability,
      [name]: value,
      custom: true,
    });
  };

  const handleAddCapability = () => {
    dispatch(addOption(newCapability));
    setNewCapability({
      name: "",
      icon: "",
      custom: true,
    });
    setShowInputFields(false);
  };

  const emmsheaders = useSelector((state) => state.emmsheader);

  const handleSubmit = (event) => {
    event.preventDefault();

    setIsSubmitting(true);

    const convertedCapacity = parseInt(formData.capacity);
    const json2 = { ...formData };
    if (formData.meetingspacetype == "emms") {
      delete json2.calendarCredentialId;
      delete json2.calendarMeetingId;
    }
    if (!json2.photoUrl) {
      delete json2.photoUrl;
    }
    json2.capacity = convertedCapacity;

    json2.customProperties = {
      ...json2.customProperties,
      features: [...userOptions],
    };
    if (!json2.customProperties.regex) {
      delete json2.customProperties.regex;
      delete json2.customProperties.regex_match_type;
    }

    const requestBody = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2 },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    if (
      formData.name.length == 0 ||
      formData?.capacity == NaN ||
      formData?.name?.length == 0 ||
      formData?.locationId?.length === 0
    ) {
      setErrorModalOpen(true);
      setErrorMessage(`Please provide all required fields`);
      setError(true);
    } else if (
      formData.meetingspacetype === "calendar" &&
      formData?.calendarMeetingId?.length === 0
    ) {
      setErrorModalOpen(true);
      setErrorMessage("Please provide a Calendar Meeting ID");
      setError(true);
    } else {
      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setIsSubmitting(false);
          setErrorModalOpen(true);
          const matchedLocation = locationOptions.find(l=>l.id ===formData.locationId)
          const location_details = `${matchedLocation.city || ""},  ${matchedLocation?.building || ""}, ${matchedLocation.floor || ""}`
          
          const combinedData = [
            ...oldMeetingSpaceData.allmeetingspaces,
            {...(response.data || {}),location_details},
          ];
          dispatch(setMeetingSpaces(combinedData));
          setErrorMessage(`Meeting room added successfully`);
          setError(false);
          setFormData({
            name: "",
            capacity: "",
            locationId: "",
            calendarMeetingId: "",
            clientId: "",
            meetingspacetype: "",
            photoUrl: " ",
            calendarCredentialId: "",
            customProperties: {},
          });
          setIsChecked(false);
          setCapacityCheckValue(0);
        })
        .catch((error) => {
          setErrorModalOpen(true);
          setErrorMessage(
            `Error creating meeting space: ${error.response.data}`
          );
          setError(true);
          setIsChecked(false);
          setCapacityCheckValue(0);
          setFormData({
            name: "",
            capacity: "",
            locationId: "",
            calendarMeetingId: "",
            clientId: "",
            meetingspacetype: "",
            photoUrl: " ",
            calendarCredentialId: "",
            customProperties: {},
          });
        });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "shortNavigation") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          shortNavigation: value,
        },
      }));
    } else if (name === "GuestWiFiDetails") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          GuestWiFiDetails: value,
        },
      }));
    } else if (name === "priority") {
      const floatValue = parseFloat(value);
      if (floatValue !== 1) {
        setIsChecked(false);
        setCapacityCheckValue(0);
        setFormData((prevFormData) => ({
          ...prevFormData,
          customProperties: {
            ...prevFormData.customProperties,
            strict_cap_check: "",
            priority: floatValue,
            strict_cap_check_valid: false,
          },
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          customProperties: {
            ...prevFormData.customProperties,
            priority: floatValue,
          },
        }));
      }
    } else if (name === "regex") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          regex: value,
        },
      }));
    } else if (name === "regex_match_type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          regex_match_type: parseFloat(value),
        },
      }));
    } else if (name === "strict_cap_check_valid") {
      setIsChecked(event.target.checked);
      if (event.target.checked === false) {
        setCapacityCheckValue(0);
      }

      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          strict_cap_check_valid: Boolean(event.target.checked),
        },
      }));
    } else if (name === "strict_cap_check") {
      const floatValue = parseFloat(value);
      const isValidNumber = !isNaN(floatValue);
      setCapacityCheckValue(value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          strict_cap_check: isValidNumber ? floatValue : 0,
        },
      }));
    } else if (name === "groups") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          groups: value,
        },
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
    setFormData({
      name: "",
      capacity: "",
      locationId: "",
      customProperties: {},
      clientId: "",
      meetingspacetype: "",
      calendarMeetingId: " ",
      calendarCredentialId: "",
    });
    setCapacityCheckValue(0);
  };


  const addCustomFeaturesAsOptions = () => {
    let features = [];
    for (let i = 0; i < oldMeetingSpaceData?.allmeetingspaces?.length; i++) {
      const meetingSpace = oldMeetingSpaceData.allmeetingspaces[i];

      if (
        meetingSpace.customProperties &&
        meetingSpace.customProperties.features &&
        Array.isArray(meetingSpace.customProperties.features)
      ) {
        const features = meetingSpace.customProperties.features;
        for (let j = 0; j < features.length; j++) {
          const feature = features[j];

          const { custom } = feature;

          if (custom === true && !options.includes(feature)) {
            dispatch(addOption(feature));
          }
        }
      }
    }
  };

  const handleCalendarData = () => {
    const requestBody = {
      path: "calendar",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setCalendar(response.data));
        setCalendarOptions(response.data);
      })
      .catch((error) => {
        setErrors(true);
      });
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "130px",
          flexShrink: 0,
        }}
      >
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
          {isRequired && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
    );
  };
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        features: userOptions,
      },
    }));
  }, [userOptions]);

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Meeting Space
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <div>
                <h2>Meeting Spaces</h2>
                <h4 style={{ fontWeight: "100" }}>
                  Add meeting space for {curremms?.curremms?.name}{" "}
                </h4>
              </div>
              {!showAdvanced && (
                <div className="firstmodal">
                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Name:", true)}
                    <TextField
                      required
                      id="name"
                      name="name"
                      label="eg. Lavendar,Olive"
                      variant="outlined"
                      size="small"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Capacity:", true)}
                    <TextField
                      required
                      id="capacity"
                      name="capacity"
                      variant="outlined"
                      label="5,9,10( in numbers) "
                      value={formData.capacity}
                      size="small"
                      onChange={handleChange}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("PhotoURL:", false)}
                    <TextField
                      id="photoUrl"
                      name="photoUrl"
                      label=" in jpeg,jpg,png format"
                      variant="outlined"
                      size="small"
                      value={formData.photoUrl}
                      onChange={handleChange}
                    />
                  </div>

                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Room Priority:", true)}
                    <TextField
                      required
                      id="priority"
                      name="priority"
                      size="small"
                      label="Special or Normal Room"
                      variant="outlined"
                      value={formData?.customProperties?.priority}
                      onChange={handleChange}
                      select
                    >
                      <MenuItem value="1">Board/Special Room</MenuItem>
                      <MenuItem value="0">Normal Room</MenuItem>
                    </TextField>
                  </div>

                  {formData?.customProperties?.priority == "1" && (
                    <>
                      <div style={{ display: "flex" }}>
                        {getLabelWithAsterisk("Minimum Capacity Check:", true)}
                        <Checkbox
                          checked={isChecked}
                          onChange={handleChange}
                          name="strict_cap_check_valid"
                          color="primary"
                        />
                      </div>
                      {isChecked && (
                        <div style={{ display: "flex" }}>
                          {getLabelWithAsterisk("Capacity Check Value:", false)}
                          <TextField
                            id="strict_cap_check"
                            name="strict_cap_check"
                            label="e.g 15,20"
                            variant="outlined"
                            size="small"
                            value={capacityCheckValue}
                            onChange={handleChange}
                          />
                        </div>
                      )}
                    </>
                  )}

                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Preferred Host:", false)}
                    <TextField
                      id="regex"
                      name="regex"
                      size="small"
                      label="eg. elhi.tech"
                      variant="outlined"
                      value={formData?.customProperties?.regex}
                      onChange={handleChange}
                    />
                  </div>
                  {formData.customProperties.regex && (
                    <div style={{ display: "flex" }}>
                      {getLabelWithAsterisk("Preferred Host Type:", true)}
                      <TextField
                        required
                        id="regex_match_type"
                        name="regex_match_type"
                        size="small"
                        label="Strict/Preferred"
                        variant="outlined"
                        value={formData?.customProperties?.regex_match_type}
                        onChange={handleChange}
                        select
                      >
                        <MenuItem value="1">Strict</MenuItem>
                        <MenuItem value="2">Preferred</MenuItem>
                      </TextField>
                    </div>
                  )}

                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Short Navigation:", false)}
                    <TextField
                      required
                      id="shortNavigation"
                      name="shortNavigation"
                      label="Navigations for Room"
                      variant="outlined"
                      size="small"
                      value={formData.customProperties.shortNavigation}
                      onChange={handleChange}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {getLabelWithAsterisk("Capabilities:", false)}
                    <div className={classes.capability}>
                      <Multiselect
                        displayValue="name"
                        id="capabilties"
                        name="capabilties"
                        size="small"
                        label="capabilties"
                        value={formData.customProperties}
                        onRemove={(event) => {
                          const updatedOptions = event;
                          setUserOptions(updatedOptions);
                        }}
                        onSelect={(event) => {
                          const updatedOptions = event;

                          setUserOptions(updatedOptions);
                        }}
                        options={options}
                        selectedValues={userOptions}
                        style={{
                          chips: {
                            background: "#19433E",
                          },
                          option: {
                            background: "#778899",
                          },

                          searchBox: {
                            border: "1px  solid lightgray",
                            position: "relative",
                            width: "30ch",
                            minHeight: "50px",
                          },
                          optionContainer: {
                            maxHeight: "100px",
                            overflowY: "auto",
                          },
                        }}
                      />

                      {showInputFields ? null : (
                        <Button
                          style={{
                            textTransform: "none",
                            width: "auto",
                            padding: "4px",
                          }}
                          variant="contained"
                          size="small"
                          onClick={() => setShowInputFields(true)}
                        >
                          New Capability
                        </Button>
                      )}

                    </div>
                  </div>
                  {showInputFields && (
                    <div className={classes.inputContainer}>
                      <div style={{ display: "flex" }}>
                        {getLabelWithAsterisk("Name:", true)}
                        <TextField
                          type="text"
                          name="name"
                          size="small"
                          variant="outlined"
                          value={newCapability.name}
                          placeholder="Capability ie. HDMI, USB-C "
                          onChange={handleInputChange}
                        />
                      </div>

                      <div style={{ display: "flex" }}>
                        {getLabelWithAsterisk("Link:", true)}
                        <TextField
                          type="text"
                          name="icon"
                          size="small"
                          variant="outlined"
                          value={newCapability.icon}
                          placeholder="Link to icon"
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className={classes.buttonContainer}>
                        <Button
                          style={{
                            textTransform: "none",
                            padding: "4px",
                          }}
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => setShowInputFields(false)}
                        >
                          Close <CloseIcon fontSize="small" />
                        </Button>
                        <Button
                          style={{
                            textTransform: "none",
                            maxWidth: "10ch",
                          }}
                          type="button"
                          variant="contained"
                          onClick={handleAddCapability}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  )}

                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Wifi Details:", false)}
                    <TextField
                      id="GuestWiFiDetails"
                      label="Guest WiFi Access Details"
                      name="GuestWiFiDetails"
                      variant="outlined"
                      size="small"
                      value={formData.customProperties.GuestWiFiDetails}
                      onChange={handleChange}
                    />
                  </div>

                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("MeetingSpaceType:", true)}
                    <TextField
                      required
                      id="meetingspacetype"
                      name="meetingspacetype"
                      size="small"
                      label="EMMS or Calendar"
                      variant="outlined"
                      value={formData.meetingspacetype}
                      onChange={handleChange}
                      select
                    >
                      <MenuItem value="calendar">Calendar</MenuItem>
                      <MenuItem value="emms">EMMS</MenuItem>
                    </TextField>
                  </div>
                  {formData.meetingspacetype === "calendar" && (
                    <div style={{ display: "flex" }}>
                      {getLabelWithAsterisk("Calendar Credentials:", true)}
                      <TextField
                        required
                        id="calendarCredentialId"
                        name="calendarCredentialId"
                        variant="outlined"
                        size="small"
                        label="Calendar credential ID "
                        value={formData.calendarCredentialId}
                        onChange={handleChange}
                        select
                      >
                        {calendarOptions?.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.credentialName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                  )}
                  {formData.meetingspacetype === "calendar" && (
                    <div style={{ display: "flex" }}>
                      {getLabelWithAsterisk("Calendar Meeting ID:", true)}
                      <CalendarMeetingIdField
                        credential={selectedCalendarCredential}
                        value={formData.calendarMeetingId}
                        takenIds={linkedCalendarIds(oldMeetingSpaceData?.allmeetingspaces)}
                        onChange={(calendarMeetingId) =>
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            calendarMeetingId,
                          }))
                        }
                      />
                    </div>
                  )}
                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Location ID:", true)}
                    <TextField
                      required
                      id="locationId"
                      name="locationId"
                      variant="outlined"
                      label="eg. Main Building"
                      size="small"
                      value={formData.locationId}
                      onChange={handleChange}
                      select
                      style={{}}
                    >
                      {locationOptions?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          <span style={{ textTransform: "uppercase" }}>
                            {option.floor} FLOOR,{" "}
                            {option.building.toUpperCase()},{" "}
                            {option.city.toUpperCase()}
                          </span>
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                  <div style={{ display: "flex" }}>
                    {getLabelWithAsterisk("Group:", true)}
                    <TextField
                      required
                      id="groups"
                      name="groups"
                      variant="outlined"
                      label="eg.Group"
                      size="small"
                      value={formData?.customProperties?.groups}
                      onChange={handleChange}
                      select
                      style={{}}
                    >
                      {groups?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          <span style={{ textTransform: "uppercase" }}>
                            {option.name}
                          </span>
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </div>
              )}
              <div className={classes.buttonContainer}>
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  variant="outlined"
                  color="primary"
                  onClick={toggleAdvanced}
                  startIcon={showAdvanced ? <ArrowBackIcon /> : null}
                >
                  {showAdvanced ? "Back" : "Advanced"}
                </Button>
                {showAdvanced && (
                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    variant="contained"
                    color="primary"
                    onClick={toggleEditMode}
                    endIcon={!editMode ? <EditIcon /> : null}
                  >
                    {editMode ? "Save Changes" : "Edit JSON"}
                  </Button>
                )}
                {!showAdvanced && (
                  <Box 
                sx={{
                  display:"flex",
                  gap:2
                }}
                >
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                    disabled={isSubmitting}
                  >
                    Close
                  </Button>
                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                  </Button>
                  </Box>
                )}
              </div>
            </div>

            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div style={{ marginBottom: "10px" }}>
                  {Object.keys(formData.customProperties).map((key) => {
                    const value = formData.customProperties[key];
                    const isEditable = key !== "features";

                    const displayValue =
                      typeof value === "object" ? JSON.stringify(value) : value;

                    return (
                      <div key={key} style={{ margin: "15px 0" }}>
                        <TextField
                          id={key}
                          name={key}
                          label={key}
                          disabled={!isEditable}
                          variant="outlined"
                          size="small"
                          value={displayValue}
                          onChange={handleCustomPropertyChange}
                        />
                      </div>
                    );
                  })}
                </div>
                {Object.keys(formData.customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            {showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(formData.customProperties, null, 2)}
                </pre>
              </div>
            )}
            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                <h2>{error === true ? "Oops" : "Congratulations"}</h2>
                <p>{errorMessage}</p>
                <Button
                  style={{ textTransform: "none", marginLeft: "75%" }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
